var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DefaultCard } from "../../../../../components/DefaultCard";
import { CustomRadioGroup } from "../../../../../components/Forms/CustomRadioGroup";
import { TipoImovelEnum } from "../../../../../model/enums/TipoImovelEnum";
import { defaultParcela, generateErrorFields, handleMountCondition, handleScrollTop, outrosOpt, useRequerimentoContext, } from "../../context/RequerimentoContext";
import { DadosImovel } from "../../../../../model/DadosImovel";
import { ParcelaImovel } from "../../../../../model/ParcelaImovel";
import { ParcelaImovelCadastro } from "../../common/ParcelaImovelCadastro";
import { Grid } from "@mui/material";
import { ShowContent } from "../../../../../components/ShowContent";
import { ModoCRUDEnum } from "../../../../../model/enums/ModoCRUDEnum";
import { hasErrors, hasValue } from "../../../../utils/ValidationUtils";
import { SimpleTable } from "../../../../../components/SimpleTable/SimpleTable";
import { prettyArea } from "../DadosImovelUsucapiaoRural";
import { DadosParcelaMunicipioAtual } from "../../common/DadosParcelaMunicipioAtual";
import { DefaultDropDown } from "../../../../../components/DefaultDropDown";
import { OrgaoResponsavelEnum } from "../../../../../model/enums/OrgaoResponsavelEnum";
import { NumericField } from "../../../../../components/Forms/NumericField";
import { DadosProjetoFundiario } from "../../common/DadosProjetoFundiario";
import { useCacheStore } from "../../../../../stores/CacheStore";
import { AuthConstants } from "../../../../../util/auth-constants";
import { CustomInputForm } from "../../../../../components/Forms/CustomInputForm";
import { MunicipioOrigemSelector } from "../../../../../components/MunicipioOrigemSelector";
import { HandleError } from "../../../../utils/HandleError";
import { CampoLoteamento, otherProjOption, } from "../../../../../components/fields/CampoLoteamento";
import { TipoProjetoFundiariosEnum } from "../../../../../model/enums/TipoProjetoFundiariosEnum";
import { CampoQuadra } from "../../../../../components/fields/CampoQuadra";
import { CampoLote } from "../../../../../components/fields/CampoLote";
import { resolve } from "../../../View/CommonView";
import { MunicipioSelector } from "../../../../../components/Selectors/MunicipioSelector";
import { UfEnum } from "../../../../../model/enums/UfEnum";
import { NAO_SEI_INFO_MUNI_AT, NAO_SEI_INFO_MUNI_DESC, } from "../../../../../util/CommonUtils";
var columns = [
    { label: "Denominação da Parcela", value: "denominacao" },
    { label: "Área(HA)", value: "area" },
    { label: "Município", value: "municipio" },
];
var naoSeiMunicipioAtual = {
    id: 0,
    nome: "Não sei informar o município atual",
    uf: "",
};
var defaultDadosImovelLimpo = __assign(__assign({}, new DadosImovel()), { tipoImovel: TipoImovelEnum.RURAL, municipioOrigem: NAO_SEI_INFO_MUNI_DESC, municipioDesmembrado: NAO_SEI_INFO_MUNI_AT });
var orgaosResponsaveisOptionsUrbano = [
    {
        value: OrgaoResponsavelEnum.DEP_TERRAS_COLONIZACAO,
        label: "DTC - Departamento de Terras e Colonização",
    },
    {
        value: OrgaoResponsavelEnum.CONPANHIA_PLAN_PROD,
        label: "CPP - Companhia de Planejamento de Produção",
    },
    {
        value: OrgaoResponsavelEnum.CODEMAT,
        label: "CODEMAT - Companhia de Desenvolvimento do Estado de Mato Grosso",
    },
    {
        value: OrgaoResponsavelEnum.INTERMAT_DTC,
        label: "INTERMAT - Instituto de Terras de Mato Grosso",
    },
];
export var DadosImovelCertIntTeor = function (_a) {
    var _b, _c, _d, _e, _f;
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, requerimento = _a.requerimento, onValidate = _a.onValidate, onChange = _a.onChange;
    // region Constants
    var defaultHandleAddParcelaImovel = useRequerimentoContext().defaultHandleAddParcelaImovel;
    var _g = useState(null), indexSelecionadoParcela = _g[0], setIndexSelecionadoParcela = _g[1];
    var _h = useState(new ParcelaImovel()), parcelaImovel = _h[0], setParcelaImovel = _h[1];
    var _j = useState(__assign(__assign({}, new DadosImovel()), { tipoImovel: TipoImovelEnum.RURAL, municipioOrigem: NAO_SEI_INFO_MUNI_DESC, municipioDesmembrado: NAO_SEI_INFO_MUNI_AT })), dadosImovel = _j[0], setDadosImovel = _j[1];
    var _k = useState(ModoCRUDEnum.CREATE), modoParcela = _k[0], setModoParcela = _k[1];
    var _l = useState(false), mostrarOutroProjeto = _l[0], setMostrarOutroProjeto = _l[1];
    var _m = useState(false), mostrarOutraQuadra = _m[0], setMostrarOutraQuadra = _m[1];
    var _o = useState(false), mostrarOutroLote = _o[0], setMostrarOutroLote = _o[1];
    var _p = useState(TipoImovelEnum.RURAL), tipoImovel = _p[0], setTipoImovel = _p[1];
    var _q = useState(false), enviarPecasTec = _q[0], setEnviarPecasTec = _q[1];
    var _r = useState({}), fieldErrorParcelaImovel = _r[0], setFieldErrorParcelaImovel = _r[1];
    var _s = useState(), error = _s[0], setError = _s[1];
    // endregion
    // region Hooks (useEffect)
    useEffect(function () {
        handleInitialize();
    }, []);
    useEffect(function () {
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(handleValidate);
    }, [requerimento, fieldErrorParcelaImovel, parcelaImovel, enviarPecasTec]);
    useEffect(function () {
        useCacheStore.getState().setCache(AuthConstants.PARCELA_IMOVEL_CACHE, __assign(__assign({}, parcelaImovel), { requerimentoId: requerimento === null || requerimento === void 0 ? void 0 : requerimento.id }));
    }, [parcelaImovel]);
    useEffect(function () {
        var dadosBanco = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel;
        if (dadosBanco) {
            setDadosImovel(function (prev) {
                var _a, _b, _c;
                var origemVindaDoBanco = dadosBanco === null || dadosBanco === void 0 ? void 0 : dadosBanco.municipioOrigem;
                var valorFinalOrigem = origemVindaDoBanco;
                var isNaoSeiInformar = !origemVindaDoBanco ||
                    (origemVindaDoBanco === null || origemVindaDoBanco === void 0 ? void 0 : origemVindaDoBanco.id) === NAO_SEI_INFO_MUNI_DESC.id ||
                    (origemVindaDoBanco === null || origemVindaDoBanco === void 0 ? void 0 : origemVindaDoBanco.denominacao) === NAO_SEI_INFO_MUNI_DESC.denominacao;
                if (isNaoSeiInformar) {
                    valorFinalOrigem = NAO_SEI_INFO_MUNI_DESC;
                }
                var projetoFinal = (_a = dadosBanco.projetoFundiario) !== null && _a !== void 0 ? _a : otherProjOption;
                var quadraFinal = (_b = dadosBanco.quadra) !== null && _b !== void 0 ? _b : outrosOpt;
                var loteFinal = (_c = dadosBanco.lote) !== null && _c !== void 0 ? _c : outrosOpt;
                if ((projetoFinal === null || projetoFinal === void 0 ? void 0 : projetoFinal.id) === otherProjOption.id)
                    setMostrarOutroProjeto(true);
                if ((quadraFinal === null || quadraFinal === void 0 ? void 0 : quadraFinal.denominacao) === outrosOpt.denominacao)
                    setMostrarOutraQuadra(true);
                if (loteFinal === outrosOpt)
                    setMostrarOutroLote(true);
                return __assign(__assign(__assign({}, prev), dadosBanco), { municipioOrigem: valorFinalOrigem, municipioDesmembrado: isNaoSeiInformar ? NAO_SEI_INFO_MUNI_AT : (dadosBanco.municipioDesmembrado || null), projetoFundiario: projetoFinal, quadra: quadraFinal, lote: loteFinal });
            });
        }
    }, [
        (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) === null || _b === void 0 ? void 0 : _b.id,
        (_d = (_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) === null || _c === void 0 ? void 0 : _c.municipioOrigem) === null || _d === void 0 ? void 0 : _d.id,
        (_f = (_e = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) === null || _e === void 0 ? void 0 : _e.projetoFundiario) === null || _f === void 0 ? void 0 : _f.id
    ]);
    // endregion
    // region Hooks (useMemo)
    var isImovelRural = useMemo(function () {
        return tipoImovel === TipoImovelEnum.RURAL;
    }, [tipoImovel]);
    var valuesParcela = useMemo(function () {
        var _a;
        return ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.map(function (parcela) {
            var _a, _b, _c;
            return ({
                denominacao: (_a = parcela === null || parcela === void 0 ? void 0 : parcela.denominacao) !== null && _a !== void 0 ? _a : "",
                area: prettyArea(parcela === null || parcela === void 0 ? void 0 : parcela.area) || "",
                municipio: (_c = (_b = parcela === null || parcela === void 0 ? void 0 : parcela.municipio) === null || _b === void 0 ? void 0 : _b.nome) !== null && _c !== void 0 ? _c : "",
            });
        })) || [];
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel]);
    var titleImovel = useMemo(function () {
        return isImovelRural ? "Dados do Imóvel Rural" : "Dados do Imóvel Urbano";
    }, [isImovelRural]);
    var titlePecas = useMemo(function () {
        return isImovelRural
            ? "Informe a(s) parcela(s) do Imóvel Rural em peças técnicas Convencionais"
            : "Informe a peça técnica do Imóvel Urbano";
    }, [isImovelRural]);
    // endregion
    // region Handlers
    var handleInitialize = function () {
        var _a, _b;
        var tipo = (_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) === null || _a === void 0 ? void 0 : _a.tipoImovel) !== null && _b !== void 0 ? _b : TipoImovelEnum.RURAL;
        setTipoImovel(tipo);
        if (tipo === TipoImovelEnum.URBANO) {
            initializeUrbano();
        }
        else {
            initializeRural();
        }
    };
    var initializeRural = function () {
        setDadosImovel(__assign(__assign({}, defaultDadosImovelLimpo), { tipoImovel: TipoImovelEnum.RURAL }));
        setEnviarPecasTec(true);
        setParcelaImovel(new ParcelaImovel());
        setModoParcela(ModoCRUDEnum.CREATE);
        setIndexSelecionadoParcela(null);
    };
    var initializeUrbano = function () {
        var _a, _b;
        var dadosImovelAtual = requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel;
        if (!dadosImovelAtual) {
            setDadosImovel(defaultDadosImovelLimpo);
        }
        else {
            var projetoFundiario = dadosImovelAtual.projetoFundiario, quadra = dadosImovelAtual.quadra, lote = dadosImovelAtual.lote, municipioOrigem = dadosImovelAtual.municipioOrigem;
            setMostrarOutroProjeto((projetoFundiario === null || projetoFundiario === void 0 ? void 0 : projetoFundiario.id) === otherProjOption.id);
            setMostrarOutraQuadra((quadra === null || quadra === void 0 ? void 0 : quadra.denominacao) === outrosOpt.denominacao);
            setMostrarOutroLote(lote === outrosOpt);
            var origemDefinida = municipioOrigem !== null && municipioOrigem !== void 0 ? municipioOrigem : NAO_SEI_INFO_MUNI_DESC;
            setDadosImovel(__assign(__assign({}, dadosImovelAtual), { municipioOrigem: origemDefinida, municipioDesmembrado: (_a = dadosImovelAtual.municipioDesmembrado) !== null && _a !== void 0 ? _a : (origemDefinida.id === NAO_SEI_INFO_MUNI_DESC.id ? NAO_SEI_INFO_MUNI_AT : null), projetoFundiario: projetoFundiario !== null && projetoFundiario !== void 0 ? projetoFundiario : otherProjOption, quadra: quadra !== null && quadra !== void 0 ? quadra : outrosOpt, lote: lote !== null && lote !== void 0 ? lote : outrosOpt }));
        }
        var parcelas = (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _b !== void 0 ? _b : [];
        setEnviarPecasTec(parcelas.length > 0);
        if (parcelas.length === 1) {
            handleChanges(__assign({}, parcelas[0]));
        }
    };
    var handleChangeMunicipioDescrito = function (_municipioOrigem) {
        handleDadosImovelChange(__assign(__assign({}, dadosImovel), { municipioOrigem: _municipioOrigem, municipioDesmembrado: (_municipioOrigem === null || _municipioOrigem === void 0 ? void 0 : _municipioOrigem.denominacao) === NAO_SEI_INFO_MUNI_DESC.denominacao
                ? NAO_SEI_INFO_MUNI_AT
                : null }));
    };
    var handleChanges = function (_parcelaImovel, _modoParcela) {
        var _a;
        if (_modoParcela === void 0) { _modoParcela = ModoCRUDEnum.CREATE; }
        if (!isImovelRural) {
            if (!_parcelaImovel) {
                onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: [] }));
            }
            else {
                onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: [
                        __assign(__assign({}, _parcelaImovel), { tipoImovel: TipoImovelEnum.URBANO, enviarPecasTec: (_a = _parcelaImovel === null || _parcelaImovel === void 0 ? void 0 : _parcelaImovel.enviarPecasTec) !== null && _a !== void 0 ? _a : enviarPecasTec }),
                    ] }));
            }
        }
        setParcelaImovel(_parcelaImovel ? __assign(__assign({}, _parcelaImovel), { tipoImovel: tipoImovel }) : null);
    };
    var handleTipoImovelChange = function (tipoImovel) {
        setTipoImovel(tipoImovel);
        handleChanges(__assign({}, defaultParcela));
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange({});
        var novoDadosImovel = __assign(__assign({}, new DadosImovel()), { tipoImovel: tipoImovel, municipioOrigem: NAO_SEI_INFO_MUNI_DESC, municipioDesmembrado: NAO_SEI_INFO_MUNI_AT });
        setDadosImovel(novoDadosImovel);
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: [], dadosImovel: novoDadosImovel }));
        if (!enviarPecasTec)
            setEnviarPecasTec(tipoImovel === TipoImovelEnum.RURAL);
        setFieldErrorParcelaImovel({});
    };
    var handleEnvPecTecChange = function (value) {
        setEnviarPecasTec(value);
        if (!value && !isImovelRural) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: [] }));
            handleChanges(null);
        }
    };
    var handleDadosImovelChange = function (_dadosImovel) {
        if (_dadosImovel) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { dadosImovel: __assign({}, _dadosImovel) }));
        }
        setDadosImovel(_dadosImovel);
    };
    var handleChangeParcela = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        handleChanges(__assign(__assign({}, parcelaImovel), (_a = {}, _a[name] = value, _a)));
    };
    var handleAddParcela = function () {
        var validoImovel = handleValidateForAddParcela();
        var validoParcela = handleValidateParcela();
        if (!validoImovel || !validoParcela)
            return;
        var parcelaComMunicipio = __assign(__assign({}, parcelaImovel), { municipio: dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.municipio });
        defaultHandleAddParcelaImovel({
            indexSelecionadoState: [
                indexSelecionadoParcela,
                setIndexSelecionadoParcela,
            ],
            valueState: [parcelaComMunicipio, setParcelaImovel],
            valido: true,
            requerimentoState: [
                requerimento,
                function (next) {
                    var _a;
                    var merged = __assign(__assign(__assign({}, requerimento), next), { dadosImovel: (_a = next === null || next === void 0 ? void 0 : next.dadosImovel) !== null && _a !== void 0 ? _a : requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel });
                    onChange === null || onChange === void 0 ? void 0 : onChange(merged);
                },
            ],
            modoState: [modoParcela, setModoParcela],
            fieldErrorState: [fieldErrorParcelaImovel, setFieldErrorParcelaImovel],
        });
    };
    var onHandleEditParcela = function (index) {
        var _a, _b, _c;
        if (requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel) {
            setDadosImovel(__assign(__assign({}, requerimento.dadosImovel), { municipioOrigem: (_a = requerimento.dadosImovel.municipioOrigem) !== null && _a !== void 0 ? _a : NAO_SEI_INFO_MUNI_DESC, municipioDesmembrado: (_b = requerimento.dadosImovel.municipioDesmembrado) !== null && _b !== void 0 ? _b : NAO_SEI_INFO_MUNI_AT }));
        }
        else {
            setDadosImovel(defaultDadosImovelLimpo);
        }
        handleChanges(__assign({}, (_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _c === void 0 ? void 0 : _c[index]), ModoCRUDEnum.UPDATE);
        setModoParcela(ModoCRUDEnum.UPDATE);
        setIndexSelecionadoParcela(index);
        setFieldErrorParcelaImovel({});
        handleScrollTop();
    };
    var onHandleRemoveItemParcela = function (index) {
        var _a;
        var _parcelas = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.filter(function (it) { var _a; return it !== ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[index]); })) || [];
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: __spreadArray([], _parcelas, true) }));
    };
    var handleValidate = function () {
        var _a, _b, _c, _d, _e;
        var di = dadosImovel !== null && dadosImovel !== void 0 ? dadosImovel : requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel;
        var possuiParcela = ((_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        var isEmpty = false;
        if (isImovelRural) {
            isEmpty = ((_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _c === void 0 ? void 0 : _c.length) === 0;
        }
        var _reqFieldError = {
            parcelasImovelError: isEmpty
                ? "Ao menos uma parcela do imóvel deve ser informada."
                : "",
        };
        var _errors = [
            {
                key: "numeroTituloDefinitivoError",
                condition: !possuiParcela && !hasValue(di === null || di === void 0 ? void 0 : di.numeroTituloDefinitivo),
            },
            {
                key: "orgaoResponsavelError",
                condition: !possuiParcela && !hasValue(di === null || di === void 0 ? void 0 : di.orgaoResponsavel),
            },
            {
                key: "projetoFundiarioError",
                condition: resolve(!isImovelRural, !hasValue(di === null || di === void 0 ? void 0 : di.projetoFundiario), false),
            },
            {
                key: "dataOcupacaoError",
                condition: resolve(!isImovelRural, !hasValue(di === null || di === void 0 ? void 0 : di.dataOcupacao), false),
            },
            {
                key: "cepImovelError",
                condition: resolve(!isImovelRural, !hasValue(di === null || di === void 0 ? void 0 : di.cepImovel), false),
            },
            {
                key: "quadraError",
                condition: resolve(!isImovelRural, !hasValue(di === null || di === void 0 ? void 0 : di.quadra), false),
            },
            {
                key: "loteError",
                condition: resolve(!isImovelRural, !hasValue(di === null || di === void 0 ? void 0 : di.lote), false),
            },
            {
                key: "livroFundiarioError",
                condition: !possuiParcela && !hasValue(di === null || di === void 0 ? void 0 : di.outroLivro),
            },
            {
                key: "folhaLivroFundiarioError",
                condition: !possuiParcela && !hasValue(di === null || di === void 0 ? void 0 : di.outraFolha),
            },
            {
                key: "outroProjetoError",
                condition: resolve(!isImovelRural && ((_d = di === null || di === void 0 ? void 0 : di.projetoFundiario) === null || _d === void 0 ? void 0 : _d.nome) === otherProjOption.nome, !hasValue(di === null || di === void 0 ? void 0 : di.outroProjeto), false),
            },
            {
                key: "outraQuadraError",
                condition: resolve(!isImovelRural && ((_e = di === null || di === void 0 ? void 0 : di.quadra) === null || _e === void 0 ? void 0 : _e.denominacao) === outrosOpt.denominacao, !hasValue(di === null || di === void 0 ? void 0 : di.outraQuadra), false),
            },
            {
                key: "outroLoteError",
                condition: resolve(!isImovelRural && (di === null || di === void 0 ? void 0 : di.lote) === outrosOpt, !hasValue(di === null || di === void 0 ? void 0 : di.outroLote), false),
            },
        ];
        var _fieldError = generateErrorFields(_errors, __assign(__assign({}, requerimentoFieldError), _reqFieldError));
        _fieldError.livroFundiario = _fieldError.livroFundiarioError;
        _fieldError.folhaLivroFundiario = _fieldError.folhaLivroFundiarioError;
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, _fieldError));
        var possuiErros = hasErrors(_fieldError);
        var erroParcela = enviarPecasTec && tipoImovel === TipoImovelEnum.URBANO
            ? handleValidateParcela()
            : true;
        return !possuiErros && erroParcela;
    };
    var handleValidateForAddParcela = function () {
        var di = dadosImovel !== null && dadosImovel !== void 0 ? dadosImovel : requerimento === null || requerimento === void 0 ? void 0 : requerimento.dadosImovel;
        var _reqFieldError = { parcelasImovelError: "" };
        var _errors = [
            {
                key: "numeroTituloDefinitivoError",
                condition: !hasValue(di === null || di === void 0 ? void 0 : di.numeroTituloDefinitivo),
            },
            {
                key: "orgaoResponsavelError",
                condition: !hasValue(di === null || di === void 0 ? void 0 : di.orgaoResponsavel),
            },
            { key: "livroFundiarioError", condition: !hasValue(di === null || di === void 0 ? void 0 : di.outroLivro) },
            { key: "folhaLivroFundiarioError", condition: !hasValue(di === null || di === void 0 ? void 0 : di.outraFolha) },
        ];
        var _fieldError = generateErrorFields(_errors, __assign(__assign({}, (requerimentoFieldError !== null && requerimentoFieldError !== void 0 ? requerimentoFieldError : {})), _reqFieldError));
        _fieldError.livroFundiario = _fieldError.livroFundiarioError;
        _fieldError.folhaLivroFundiario = _fieldError.folhaLivroFundiarioError;
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, _fieldError));
        return !hasErrors(_fieldError);
    };
    var handleValidateParcela = function () {
        var rt = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.responsavelTecnico;
        var pf = rt === null || rt === void 0 ? void 0 : rt.pessoaFisica;
        var _parcelaErrorField = [
            {
                key: "denominacaoError",
                condition: handleMountCondition(isImovelRural, !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.denominacao)),
            },
            {
                key: "areaError",
                condition: handleMountCondition(isImovelRural, !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area)),
            },
            { key: "codigoArtError", condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoArt) },
            {
                key: "ufConselhoClasseError",
                condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.ufConselhoClasse),
            },
            { key: "conselhoClasseError", condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.conselhoClasse) },
            { key: "numeroRegistroError", condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.numeroRegistro) },
            { key: "codigoIncraError", condition: !hasValue(rt === null || rt === void 0 ? void 0 : rt.codigoIncra) },
            { key: "cpfError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cpf) },
            { key: "nomeError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.nome) },
            { key: "emailError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.email) },
            { key: "celularError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.celular) },
            {
                key: "nomeSocialError",
                condition: !!(pf === null || pf === void 0 ? void 0 : pf.informarNomeSocial) && !hasValue(pf === null || pf === void 0 ? void 0 : pf.nomeSocial),
            },
            { key: "cepError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.cep) },
            { key: "estadoError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.estado) },
            { key: "municipioError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.municipio) },
            { key: "bairroError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.bairro) },
            { key: "numeroError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.numero) },
            { key: "enderecoError", condition: !hasValue(pf === null || pf === void 0 ? void 0 : pf.endereco) },
        ];
        var _parcelaFieldError = generateErrorFields(_parcelaErrorField, __assign({}, fieldErrorParcelaImovel));
        setFieldErrorParcelaImovel(_parcelaFieldError);
        return !hasErrors(_parcelaFieldError);
    };
    // endregion
    // region Hooks (useCallback | JXS Elements)
    var tableParcela = useCallback(function () {
        var _a;
        return (_jsx(ShowContent, __assign({ show: isImovelRural }, { children: _jsx(DefaultCard, __assign({ title: "" }, { children: _jsx(SimpleTable, { error: (_a = requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError) !== null && _a !== void 0 ? _a : "", onHandleRemoveItem: onHandleRemoveItemParcela, emptyText: "Nenhuma Parcela Inserida", indexMark: indexSelecionadoParcela !== null && indexSelecionadoParcela !== void 0 ? indexSelecionadoParcela : undefined, onHandleEdit: onHandleEditParcela, values: valuesParcela, showOptions: true, columns: columns }) })) })));
    }, [
        requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError,
        valuesParcela,
        isImovelRural,
        indexSelecionadoParcela,
    ]);
    var topChildrenRural = useCallback(function () {
        var _a;
        return (_jsxs(ShowContent, __assign({ show: isImovelRural }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(CustomInputForm, { placeholder: "Informe a denominação da Parcela", helperText: fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.denominacaoError, error: !!(fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.denominacaoError), value: (_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.denominacao) !== null && _a !== void 0 ? _a : "", label: "Denomina\u00E7\u00E3o da Parcela", id: "denominacao_parcela", onChange: handleChangeParcela, name: "denominacao", variant: "outlined", fullWidth: true, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 12 }, { children: _jsx(NumericField, { onChange: function (num) {
                            return handleChanges(__assign(__assign({}, parcelaImovel), { area: num !== null && num !== void 0 ? num : undefined }));
                        }, placeholder: "Informe a \u00E1rea em hectares", helperText: fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.areaError, value: parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area, label: "\u00C1rea (HA)", required: true, id: "area", name: "area", after: 4 }) }))] })));
    }, [
        isImovelRural,
        parcelaImovel,
        fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.areaError,
        fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.denominacaoError,
    ]);
    var topChildrenDefault = function (show) {
        var _a;
        return (_jsx(ShowContent, __assign({ show: show }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(CustomInputForm, { onChange: function (event) {
                        var _a;
                        return handleChanges(__assign(__assign({}, parcelaImovel), { codigoArt: (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value }));
                    }, placeholder: "Informe o Número da ART (Anotação de Responsabilidade Técnica) ou RRT (Registro de Responsabilidade Técnica)", label: "N\u00FAmero da ART (Anota\u00E7\u00E3o de Responsabilidade T\u00E9cnica) ou RRT (Registro de Responsabilidade T\u00E9cnica)", helperText: fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.codigoArtError, value: (_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoArt) !== null && _a !== void 0 ? _a : "", error: !!(fieldErrorParcelaImovel === null || fieldErrorParcelaImovel === void 0 ? void 0 : fieldErrorParcelaImovel.codigoArtError), id: "codigoArt_parcela", variant: "outlined", name: "codigoArt", fullWidth: true, required: true }) })) })));
    };
    var topChildren = function () {
        return (_jsx(ShowContent, __assign({ show: enviarPecasTec }, { children: _jsx(DefaultCard, __assign({ title: titlePecas }, { children: _jsxs(Grid, __assign({ container: true, spacing: 2, style: { paddingLeft: "20px" } }, { children: [_jsx(ShowContent, __assign({ show: isImovelRural }, { children: topChildrenRural() })), topChildrenDefault(true)] })) })) })));
    };
    var campoOrgaoResponsavel = useCallback(function () {
        var _a;
        var valuesList = OrgaoResponsavelEnum.getOptions();
        if (!isImovelRural) {
            valuesList = orgaosResponsaveisOptionsUrbano;
        }
        else {
            valuesList = valuesList === null || valuesList === void 0 ? void 0 : valuesList.filter(function (it) { return it.value !== OrgaoResponsavelEnum.DEP_TERRAS_COLONIZACAO; });
        }
        return (_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(DefaultDropDown, { onChange: function (value) {
                    return handleDadosImovelChange(__assign(__assign({}, dadosImovel), { orgaoResponsavel: value }));
                }, value: (_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.orgaoResponsavel) !== null && _a !== void 0 ? _a : null, label: "Órgão responsável pela titulação", fieldError: requerimentoFieldError, name: "orgaoResponsavel", values: valuesList, required: true }) })));
    }, [dadosImovel, requerimentoFieldError, isImovelRural]);
    var campoLoteamento = useCallback(function () {
        var _a;
        return (_jsx(CampoLoteamento, { onChange: function (_dadosImovelRetornado) {
                var _a, _b;
                var novoDados = __assign({}, _dadosImovelRetornado);
                var idAntigo = (_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id;
                var idNovo = (_b = novoDados.projetoFundiario) === null || _b === void 0 ? void 0 : _b.id;
                if (idAntigo !== idNovo) {
                    novoDados.quadra = null;
                    novoDados.lote = null;
                    novoDados.outraQuadra = null;
                    novoDados.outroLote = null;
                    setMostrarOutraQuadra(false);
                    setMostrarOutroLote(false);
                }
                handleDadosImovelChange(novoDados);
            }, onShowChange: function (show) {
                setMostrarOutroProjeto(show);
            }, tipo: [TipoProjetoFundiariosEnum.LoteamentoUrbano], disabled: !((_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.municipio) === null || _a === void 0 ? void 0 : _a.id), refChange: dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.municipioDesmembrado, fieldError: requerimentoFieldError, label: "Projeto de Loteamento", value: dadosImovel, addOther: true, required: true }));
    }, [requerimentoFieldError, dadosImovel]);
    var campoQuadra = useCallback(function () {
        var _a;
        return (_jsx(CampoQuadra, { onChange: function (_dadosImovelRetornado) {
                var novoDados = __assign({}, _dadosImovelRetornado);
                var qAntiga = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.quadra;
                var qNova = novoDados.quadra;
                var mudou = (qAntiga === null || qAntiga === void 0 ? void 0 : qAntiga.id) !== (qNova === null || qNova === void 0 ? void 0 : qNova.id) || (qAntiga === null || qAntiga === void 0 ? void 0 : qAntiga.denominacao) !== (qNova === null || qNova === void 0 ? void 0 : qNova.denominacao);
                if (mudou) {
                    novoDados.lote = null;
                    novoDados.outroLote = null;
                    setMostrarOutroLote(false);
                }
                handleDadosImovelChange(novoDados);
            }, onShowChange: function (show) { return setMostrarOutraQuadra(show); }, disabled: !((_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id), refChange: dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.projetoFundiario, fieldError: requerimentoFieldError, value: dadosImovel, addOther: true, required: true }));
    }, [requerimentoFieldError, dadosImovel]);
    var campoLote = useCallback(function () {
        var _a;
        return (_jsx(CampoLote, { onChange: function (_dadosImovel) {
                return handleDadosImovelChange(_dadosImovel);
            }, onShowChange: function (show) { return setMostrarOutroLote(show); }, disabled: !((_a = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.quadra) === null || _a === void 0 ? void 0 : _a.id), refChange: dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.quadra, value: dadosImovel, fieldError: requerimentoFieldError, addOther: true, required: true }));
    }, [requerimentoFieldError, dadosImovel]);
    // endregion
    return (_jsxs(_Fragment, { children: [_jsx(DefaultCard, __assign({ title: "", style: { padding: "31px" } }, { children: _jsx(CustomRadioGroup, { onChange: function (event) {
                        return handleTipoImovelChange(event.target.value);
                    }, options: TipoImovelEnum.getOptions(), label: "Tipo do Im\u00F3vel?", name: "tipo-imovel-opts", value: tipoImovel, required: true, collumn: true }, "tipo-imovel-opts") })), _jsx(ParcelaImovelCadastro, __assign({ onEviarPecasTecChange: function (value) {
                    return handleEnvPecTecChange(value);
                }, onFieldErrorChange: function (err) {
                    return setFieldErrorParcelaImovel(__assign({}, err));
                }, onChange: function (value) { return handleChanges(__assign({}, value)); }, isEdit: modoParcela === ModoCRUDEnum.UPDATE, fieldError: fieldErrorParcelaImovel, showEnvPcsTecCard: !isImovelRural, enviarPecasTecInpt: enviarPecasTec, parcelaImovel: parcelaImovel, handleAdd: handleAddParcela, topChildren: topChildren(), showBtnAdd: isImovelRural, table: tableParcela(), isView: false }, { children: _jsxs(DadosParcelaMunicipioAtual, __assign({ onChange: function (_dadosImovel) {
                        return handleDadosImovelChange(_dadosImovel);
                    }, fieldChildren: campoOrgaoResponsavel(), fieldError: requerimentoFieldError, parcelaImovel: dadosImovel, showMunicipios: false, title: titleImovel, numTitFull: false }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: _jsx(MunicipioOrigemSelector, { value: (dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.municipioOrigem) || null, onChange: handleChangeMunicipioDescrito, label: "Munic\u00EDpio descrito no documento", defaultValue: NAO_SEI_INFO_MUNI_DESC, fieldError: requerimentoFieldError, name: "municipioOrigem", required: true }, "municipioOrigem") })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: _jsx(MunicipioSelector, { onChange: function (m) {
                                    handleDadosImovelChange(__assign(__assign({}, dadosImovel), { municipio: m || undefined }));
                                }, value: (dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.municipio) || naoSeiMunicipioAtual, fieldError: requerimentoFieldError, label: "Munic\u00EDpio Atual", name: "municipio", uf: UfEnum.MT, required: true }) })), _jsx(ShowContent, __assign({ show: !isImovelRural }, { children: _jsx(DadosProjetoFundiario, { handleChanges: function (value) {
                                    return handleDadosImovelChange(value);
                                }, showOutroProjeto: mostrarOutroProjeto, showOutraQuadra: mostrarOutraQuadra, fieldError: requerimentoFieldError, campoLoteamento: campoLoteamento(), showOutroLote: mostrarOutroLote, dadosImovel: dadosImovel, campoQuadra: campoQuadra(), showMap: !isImovelRural, campoLote: campoLote(), showCepData: true }) }))] })) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
